import React, { useEffect, useState } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import Link from 'next/link';
import Countdown from 'react-countdown';
import ReactMarkdown from 'react-markdown';
import { useWeb3React } from '@web3-react/core';

import styles from '../styles/Shop.module.scss';
import ConnectButton from './ConnectButton';
import useRaffles from '../hooks/useRaffles';
import AuctionEntryForm from './AuctionEntryForm';
import TokenGate from './TokenGate';

const Auction = ({ raffleKey }) => {
  const raffle = useRaffles(raffleKey);

  const { active } = useWeb3React();
  const [showCountdown, setShowCountdown] = useState(false);
  const [auctionStarted, setAuctionStarted] = useState(false);

  const [auctionStart, setAuctionStart] = useState(new Date(0));

  useEffect(() => {
    setAuctionStart(new Date(raffle.start_time));
  }, [raffle]);

  useEffect(() => {
    setShowCountdown(true); // only render countdown on client
    setAuctionStarted(auctionStart.getTime() < Date.now());
  }, [auctionStart]);

  return (
    <>
      <div className="d-flex">
        <div>
          <Link href="/shop">
            <a className="btn btn-light rounded-pill px-4">
              <span className="me-1">&#10094;</span> Back
            </a>
          </Link>
        </div>
        {showCountdown && !auctionStarted ? (
          <div className="ms-auto">
            <div className="btn btn-light rounded-pill px-4">
              Starting in{' '}
              <strong>
                <Countdown
                  date={auctionStart}
                  daysInHours
                  onComplete={() => setAuctionStarted(true)}
                />
              </strong>
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
      <article>
        <div className="row">
          <div className="col-12 col-lg-5 py-3">
            <div
              style={{
                borderRadius: '20px',
                overflow: 'hidden',
                display: 'flex',
              }}
            >
              <Image
                src={raffle.image}
                width={1200}
                height={1200}
                alt={raffle.title}
              />
            </div>
          </div>
          <div className="col-12 col-lg-7 py-3">
            <div className={styles.card}>
              <div className="p-4 p-md-5">
                <h1 className="display-3 title">{raffle.title}</h1>
                {raffle.description ? (
                  <ReactMarkdown className="lead fw-normal">
                    {raffle.description}
                  </ReactMarkdown>
                ) : (
                  ''
                )}
                <p className="fs-3 fw-bold">The Rules</p>
                <ol>
                  {raffle.rules.map((s, i) => (
                    <li key={i} className="mb-2 fw-bold">
                      <p className="fw-normal">{s}</p>
                    </li>
                  ))}
                </ol>
              </div>
              <div className="p-4 p-md-5" style={{ backgroundColor: '#eee' }}>
                <div>
                  {active ? (
                    <TokenGate onlyWrapped={raffle.wrapped}>
                      <AuctionEntryForm
                        auctionId={raffle.auction_id}
                        purchaseLimit={raffle.purchase_limit}
                        winnerInstructions={raffle.winner_instructions}
                      />
                    </TokenGate>
                  ) : (
                    <div className="py-5 text-center">
                      <ConnectButton />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    </>
  );
};

export default Auction;
